const getDateTime = (date: Date) => {
	const dateTime = new Date(date);
	dateTime.setFullYear(0);
	dateTime.setMonth(0);
	dateTime.setDate(0);
	dateTime.setSeconds(0);
	dateTime.setMilliseconds(0);
	return dateTime;
}

export default getDateTime;